var map = {
	"./basic/assets/languages/vi.json": 504,
	"./cmbi/assets/languages/vi.json": 40907,
	"./eif/assets/languages/vi.json": 25174,
	"./fubon/assets/languages/vi.json": 29174,
	"./scb/assets/languages/vi.json": 23094,
	"./ttl/assets/languages/vi.json": 43450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59201;